require('./locations-list/locations-list.scss');
var BaseViews = require('./base');
var CartLocationDisplay = require('./cart/cart-location-display');
var LocationsList = Backbone.Marionette.CompositeView.extend({
    template: require('./locations-list/locations-list.html'),
    className: 'fmcy-locations-list container-fluid',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                resizeHeightToScreenSize: true,
                actionButton: true,
                clickableLocationInfo: false
            }
        );
    },
    childView: CartLocationDisplay,
    childViewContainer: '.fmcy-locations-list-container',
    childViewOptions: function (model, index) {
        var opts = {
            model: model,
            hidePhotoSmallScreen: false,
            actionButton: this.options.actionButton,
            buttonText: 'Select',
            clickableLocationInfo: this.options.clickableLocationInfo
        };
        return opts;
    },
    childEvents: {
      'item:clicked': function (view, model) {
        this.trigger('item:clicked', model);
      },
      'info:clicked': function (view, model) {
        this.trigger('info:clicked', model);
      }
    },
    _onWindowResize: function () {
      this.$el.css('min-height', $(window).height());
      if ($(window).width() > 900) {
        this.$el.css('width', 450);
      } else {
        this.$el.css('width', $(window).width());
      }
    },
    onRender: function () {
      if (this.options.resizeHeightToScreenSize) {
        this.$el.css('padding-bottom', '200px');
        $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
        this._onWindowResize();
      }
      BaseViews.LayoutView.prototype.onRender.call(this);
    },
    onDestroy: function () {
      if (this.options.resizeHeightToScreenSize) {
        $(window).off('resize.' + this.cid);
      }
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});
module.exports = LocationsList;



/** WEBPACK FOOTER **
 ** ./assets/js/common/locations-list.js
 **/